<div class="engine" [ngClass]="{'top': (hasOpenModals$ | async) && !(isWidget$ | async)}">
  <div class="container container-lg no-container-widget p-0">
    <div class="engine-container" id="searchEngine"
      [ngClass]="{'top': (hasOpenModals$ | async) && !(isWidget$ | async)}">
      <app-engine-tabs [selectedTabOuter]="selectedTab" [isB2B]="isB2B$ | async" (selectedTab)="onSelectedTab($event)">
      </app-engine-tabs>
      <app-engine-body [holidaySearchParams]="holidaySearchParams" [cruiseSearchParams]="cruiseSearchParams" [selectedTab]="selectedTab"></app-engine-body>
    </div>
    <!-- // FIXME: da decommentare non appena è collegato nell'engine la selezione delle strutture -->
    <!--    <div class="engine__more-options" *ngIf="(isB2B$ | async)">-->
    <!--      <a href="" class="e-link e-link&#45;&#45;underline e-link&#45;&#45;blue e-link__more">-->
    <!--        <span><i class="icon-chevron-down"></i>Mostra più opzioni di ricerca</span>-->
    <!--        <span *ngIf=""><i class="icon-chevron-up"></i>Mostra meno opzioni di ricerca</span>-->
    <!--      </a>-->
    <!--    </div>-->
  </div>
</div>
